import { createRouter } from '../common';

const appRouterUrls = {
  home: () => '/',
  lookMaNoHands: () => '/look-ma-no-hands',
  workingFromHome: () => '/working-from-home',
  expertAssignment: () => '/expert-assignment',
  theDeveloperAndTheAi: () => '/the-developer-and-the-ai',
  dataIsKey: () => '/data-is-key',
  azureFunctionsDurableTasks: () => '/azure-functions-durable-tasks'
};

export const router = createRouter({
  home: appRouterUrls.home(),
  lookMaNoHands: appRouterUrls.lookMaNoHands(),
  workingFromHome: appRouterUrls.workingFromHome(),
  expertAssignment: appRouterUrls.expertAssignment(),
  theDeveloperAndTheAi: appRouterUrls.theDeveloperAndTheAi(),
  dataIsKey: appRouterUrls.dataIsKey(),
  azureFunctionsDurableTasks: appRouterUrls.azureFunctionsDurableTasks()
});

function mapGo<T extends { [k in keyof T]: (...a: Parameters<T[k]>) => string }>(urls: T) {

  const entries = Object
    .entries(urls as { [k: string]: (...a: any) => string });

  return entries
    .reduce((o, [key, fn]) => {

      o[key] = (...a: any) => router.go(fn(...(a || [])));

      return o;
    }, {} as { [k: string]: (...a: Parameters<T[keyof T]>) => void });
}

function mapHRef<T extends { [k in keyof T]: (...a: Parameters<T[k]>) => string }>(urls: T) {

  const entries = Object
    .entries(urls as { [k: string]: (...a: any) => string });

  return entries
    .reduce((o, [key, fn]) => {

      o[key] = (...a: any) => router.href(fn(...(a || [])));

      return o;
    }, {} as { [k: string]: (...a: Parameters<T[keyof T]>) => { href: string } });
}

function mapClick<T extends { [k in keyof T]: (...a: Parameters<T[k]>) => string }>(urls: T) {

  const entries = Object
    .entries(urls as { [k: string]: (...a: any) => string });

  return entries
    .reduce((o, [key, fn]) => {

      o[key] = (...a: any) => router.onClick(fn(...(a || [])));

      return o;
    }, {} as { [k: string]: (...a: Parameters<T[keyof T]>) => { onClick: (e: MouseEvent) => void } });
}

export const appRouter = {
  ...router,
  go: mapGo(appRouterUrls),
  href: mapHRef(appRouterUrls),
  click: mapClick(appRouterUrls),
  init: () => router()
}
